import React from "react";
import TechBall from "../components/TechBall";

const Tech = () => {
  return (
    <>
      <div className="mt-10">
        <h1 className="text-4xl font-bold text-white text-center">Techs</h1>
      </div>
      <div className="flex items-center justify-center mt-5">
        <TechBall icon="https://cdn.iconscout.com/icon/free/png-256/free-java-59-1174952.png?f=avif&w=128"></TechBall>
        <TechBall icon="https://cdn.iconscout.com/icon/free/png-512/free-spring-boot-5285303-4406740.png?f=webp&w=256"></TechBall>
        <TechBall icon="https://cdn.iconscout.com/icon/free/png-256/free-html5-2038876-1720089.png?f=avif&w=128"></TechBall>
        <TechBall icon="https://cdn.iconscout.com/icon/free/png-256/mongodb-3-1175138.png?f=avif&w=128"></TechBall>
        <TechBall icon="https://cdn.iconscout.com/icon/free/png-512/free-postgresql-11-1175122.png?f=webp&w=256"></TechBall>
        <TechBall icon="https://cdn.iconscout.com/icon/free/png-256/free-flutter-2038877-1720090.png?f=avif&w=128"></TechBall>
        <TechBall icon="https://cdn.iconscout.com/icon/free/png-256/free-dart-69-458262.png?f=avif&w=128"></TechBall>
        <TechBall icon="https://cdn.iconscout.com/icon/free/png-256/free-css3-11-1175239.png?f=avif&w=128"></TechBall>
        <TechBall icon="https://cdn.iconscout.com/icon/free/png-256/free-js-45-458325.png?f=avif&w=128"></TechBall>
        <TechBall icon="https://cdn.iconscout.com/icon/premium/png-256-thumb/react-js-5363133-4488922.png?f=avif&w=128"></TechBall>
        <TechBall icon="https://cdn.iconscout.com/icon/free/png-256/node-js-1174925.png?f=avif&w=128"></TechBall>
        <TechBall icon="https://cdn.iconscout.com/icon/free/png-256/git-225996.png?f=avif&w=128"></TechBall>
        <TechBall icon="https://cdn.iconscout.com/icon/free/png-256/figma-682083.png?f=avif&w=128"></TechBall>
      </div>
    </>
  );
};

export default Tech;
